import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AppStoreNotificationsService} from '../../../api/api/appStoreNotifications.service';
import {AppStoreNotificationWrapper} from '../../../api/model/appStoreNotificationWrapper';

@Injectable()
export class AppStoreNotificationsDetailService {

  notification$ = new BehaviorSubject<AppStoreNotificationWrapper>(null);

  constructor(private appStoreNotificationsService: AppStoreNotificationsService) { }

  refresh(notificationId: any) {
    const notificationValue = this.notification$.value;
    if (!notificationValue || notificationValue.internalId !== notificationId) {
      // refresh
      this.appStoreNotificationsService.getAppStoreNotificationsDetails(notificationId)
        .subscribe(
          notification => {
            this.notification$.next(notification);
          }
        );
    }
  }

  refreshCurrent() {
    if (this.notification$.value) {
      const notificationId = this.notification$.value.internalId;
      // refresh
      this.appStoreNotificationsService.getAppStoreNotificationsDetails(notificationId)
        .subscribe(
          notification => {
            this.notification$.next(notification);
          }
        );
    }
  }
}
